import React from 'react';
import styles from './overview.module.css';
import CTAButton from "../../../common/v2/CTA-Button/cta-button";
import Lazy from "../../../common/lazy-scroll/Lazy";
import {HOME_PAGE_CONTENT} from "../homePageContent";

const ProgramOverview: React.FC = () => {
    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    <Lazy SrcImage={"/images/home/programoverview.jpg"}
                          className={styles.image}
                          alt={"Espace chaleureux de la garderie"}
                    />
                </div>
                <div className={styles.text_content}>
                    <h2 className={styles.section_title}>
                        {HOME_PAGE_CONTENT.programOverView.title}
                    </h2>
                    <p className={styles.intro_paragraph}>
                        {HOME_PAGE_CONTENT.programOverView.paragraph}
                    </p>
                    <CTAButton text={"En Savoir Plus"} href={"/Programes"}/>

                </div>
            </div>
        </section>
    );
};

export default ProgramOverview;
